export default __webpack_public_path__ + "static/media/Example.a1139a0f.svg";